var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    d: "M8.00013 1.33325C6.20013 1.33325 4.53347 2.06659 3.2668 3.33325C2.00013 4.59992 1.33347 6.33325 1.33347 8.13325C1.33347 11.7333 4.2668 14.6666 7.8668 14.6666H8.00013C11.7328 14.5999 14.6668 11.5999 14.6668 7.86659C14.6668 4.26659 11.7328 1.33325 8.13347 1.33325H8.00013ZM7.4668 5.05332C7.4668 4.71999 7.73347 4.51998 8.00013 4.51998C8.33347 4.51998 8.53347 4.78665 8.53347 5.05332V8.38665C8.53347 8.71998 8.2668 8.91998 8.00013 8.91998C7.6668 8.91998 7.4668 8.71998 7.4668 8.38665V5.05332ZM8 11.4867C7.52135 11.4867 7.13333 11.0987 7.13333 10.6201C7.13333 10.1414 7.52135 9.75338 8 9.75338C8.47865 9.75338 8.86667 10.1414 8.86667 10.6201C8.86667 11.0987 8.47865 11.4867 8 11.4867Z",
    fill: "#D21C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fabc8ef2b9f226aa58369ad0a0c84d04.svg";
export { ForwardRef as ReactComponent };